import { render, staticRenderFns } from "./BaseSplitBlock.vue?vue&type=template&id=a4d8af66"
import script from "./BaseSplitBlock.vue?vue&type=script&lang=js"
export * from "./BaseSplitBlock.vue?vue&type=script&lang=js"
import style0 from "./BaseSplitBlock.vue?vue&type=style&index=0&id=a4d8af66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports